module.exports = __webpack_public_path__ + "img/logooffice1.28eb3291.png";